import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { AuthService } from '@core/auth.service'
import { RedirectorPage } from './page/private/redirector/redirector.page'

let routes: Routes = [
   {
      path: '',
      redirectTo: '/home',
      pathMatch: 'full',
   },
   {
      path: 'home',
      canActivate: [AuthService],
      component: RedirectorPage,
   },
   {
      path: 'dashboard',
      loadChildren: () => import('./page/private/dashboard/dashboard-page.module').then((mod) => mod.DashboardPageModule),
      canActivate: [AuthService],
   },
   {
      path: 'documents',
      loadChildren: () => import('./page/private/documents/documents-page.module').then((mod) => mod.DocumentsPageModule),
      canActivate: [AuthService],
   },
   {
      path: 'partners',
      loadChildren: () => import('./page/private/partners/partners-page.module').then((mod) => mod.PartnersPageModule),
      canActivate: [AuthService],
   },
   {
      path: 'calendar',
      loadChildren: () => import('./page/private/calendar/calendar-page.module').then((mod) => mod.CalendarPageModule),
      canActivate: [AuthService],
   },
   {
      path: 'doodles',
      loadChildren: () => import('./page/private/doodles/doodles-page.module').then((mod) => mod.DoodlesPageModule),
      canActivate: [AuthService],
   },
   {
      path: 'discussions',
      loadChildren: () => import('./page/private/discussions/discussions-page.module').then((mod) => mod.DiscussionsPageModule),
      canActivate: [AuthService],
   },
   {
      path: 'mailing-list',
      loadChildren: () => import('./page/private/mailing-list/mailing-list-page.module').then((mod) => mod.MailingListPageModule),
      canActivate: [AuthService],
   },
   {
      path: 'error',
      canActivate: [AuthService],
      loadChildren: () => import('./page/private/error/error-page.module').then((mod) => mod.ErrorPageModule),
   },
   { path: '**', redirectTo: '/error' },
]

@NgModule({
   imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
   exports: [RouterModule],
   providers: [AuthService],
})
export class AppRoutingModule {}

